import { optimisticSet } from '#lib/stores/optimistic.js';
import { userStore } from '#lib/stores/user.js';
import { apiDoNotDisturb, apiDoNotDisturbDelete } from '#lib/types/generated/index.js';
import { DateTime } from 'luxon';
import { get, writable } from 'svelte/store';
import { now } from './time';

type DoNotDisturbStore = {
	enabled: boolean;
	end: DateTime | null;
};

export const doNotDisturbStore = writable<DoNotDisturbStore>({
	enabled: false,
	end: null
});

export function enableDoNotDisturb(date: DateTime) {
	// Only enable if date is in the future
	if (date < get(now)) {
		return Promise.resolve();
	}

	const iso = date.toISO();
	if (!iso) {
		return Promise.resolve();
	}

	return optimisticSet(
		doNotDisturbStore,
		{
			enabled: true,
			end: date
		},
		() =>
			apiDoNotDisturb({
				until: iso
			})
	);
}

export function disableDoNotDisturb() {
	return optimisticSet(
		doNotDisturbStore,
		{
			enabled: false,
			end: null
		},
		() => apiDoNotDisturbDelete()
	);
}

export function isDoNotDisturbActive(): boolean {
	const { end } = get(doNotDisturbStore);
	if (!end) {
		return false;
	}

	return end > get(now);
}

userStore.subscribe((user) => {
	// Refresh do not disturb status from user.doNotDisturb property
	if (user.doNotDisturbUntil && user.doNotDisturbUntil > get(now)) {
		doNotDisturbStore.set({
			enabled: true,
			end: user.doNotDisturbUntil
		});
	} else {
		doNotDisturbStore.set({
			enabled: false,
			end: null
		});
	}

	return () => {};
});
